import { comCheckFuelCardTransactionAction, FSComCheckFuelCardTransactionAction } from "@mobile-dev/platform/common/redux/actions/ComCheckFuelCardAction";
import { clearComCheckPreEdit, clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router';
import { toast } from "react-toastify";
import { comCheckAdditionalFields, comCheckFuelCardFieldValidation, dynamicRegex, getApplicationFlow, getCarrierEnteredMobileNumber, isEclipseOpsTruck, showAlert, toastOptions, validateComdataPreEditRange } from "../../../../../Utils/Utility";
import LoaderSubmitButton from "../../../../Common/LoaderSubmitButton";
import jwt from 'jsonwebtoken';
import moment from "moment";

function ComCheckFuelCardDialog({ open = false, id, preEditDetails, card_num, unit_num, amount, remainingAmount, selection, warehouse_id, load_control_num, serviceFee }) {
    const [show, setShow] = useState(open);
    const [counter, setCounter] = useState(6);
    const history = useHistory();
    const dispatch = useDispatch();
    const [fieldsArr, setFieldsArr] = useState([]);
    const [fuelCardFields, setFuelCardFields] = useState({});
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [errorStatus, setErrorStatus] = useState('');
    const comCheckFuelCardtTransaction = useSelector(state => state.comCheckFuelCard);
    const toastId = useRef(null);
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : userData.phone_number;

    const handleClose = () => {
        setShow(false);
        dispatch(clearComCheckPreEdit());
    }

    useEffect(() => {
        dispatch(clearError());
    }, []);

    useEffect(() => {
        inputValues();
    }, [preEditDetails]);

    useEffect(() => {
        if (comCheckFuelCardtTransaction?.error?.response) {

            if (!toast.isActive(toastId.current)) {
                toastOptions.autoClose = false;
                toastOptions.type = 'warning';
                toastId.current = toast(comCheckFuelCardtTransaction?.error?.response?.data, toastOptions);
            }
        }
        else if (comCheckFuelCardtTransaction.comCheckFuelCardtTransaction) {
            handleClose();
        }
    }, [comCheckFuelCardtTransaction]);

    function inputValues() {
        preEditDetails.forEach((item, i) => {
            for (let key in item) {

                const validationValues = item[key];
                comCheckFuelCardFieldValidation.set(key, { type: validationValues[0], value: validationValues[1] });
                let fieldLabel = comCheckAdditionalFields.get(key);
                let field = <div key={key} className="form-group">
                    <label htmlFor={key}>{fieldLabel}</label>
                    <input type="text" className="form-control" placeholder={fieldLabel}
                        {...register(key, { required: true })} />
                </div>;
                setFieldsArr((fieldsArr) => [...fieldsArr, field]);

            }
        });
    }


    async function fuelcardToken(fuelCardRequest) {
        let secret_key = userData.sub;
        let token = await jwt.sign(
            fuelCardRequest,
            secret_key
        );
        return token;
    }

    const onSubmit = (data) => {
        let isSuccess = true;
        Object.keys(data).forEach(key => {
            const vObj = comCheckFuelCardFieldValidation.get(key);
            if (vObj.type === 'V' && data[key] !== vObj.value) {
                showAlert(toast.TYPE.WARNING, `Please enter correct value for ${comCheckAdditionalFields.get(key)}`);
                isSuccess = false;

            }
            else if (vObj.type === 'E' && !(dynamicRegex(vObj.value, data[key]))) {
                showAlert(toast.TYPE.WARNING, `Please enter correct value for ${comCheckAdditionalFields.get(key)}`);
                isSuccess = false;
            }
            else if (vObj.type === 'R' && !validateComdataPreEditRange(vObj.value, data[key])) {
                showAlert(toast.TYPE.WARNING, `Please enter correct value for ${comCheckAdditionalFields.get(key)}`);
                isSuccess = false;
            }
        });
        if (isSuccess) {
            if (isEclipseOpsTruck(load)) {
                const transactionData = {
                    recID: id,
                    transactionType: "COMDATA_FUEL_CARD",
                    cardNumber: card_num,
                    driverLastName: auth?.user?.attributes?.family_name,
                    driverFirstName: auth?.user?.attributes?.given_name,
                    transactionDateTime: moment(),
                    timeZone: "UTC+6",
                    unitNum: unit_num,
                    relaySiteId: warehouse_id,
                    fullAmount: amount,
                    tabletype: "eclipseOps",
                    serviceFee: serviceFee,
                    paymentType: selection,
                    user_number: driver_phone,
                    ...data
                }
                dispatch(FSComCheckFuelCardTransactionAction(transactionData))
            } else {
                let load_id = id;
                const fuelCardRequest = { ...data, amount, unit_num, card_num, load_id, warehouse_id, load_control_num };
                const token = fuelcardToken(fuelCardRequest);
                if (token) {
                    token.then(function (result) {
                        let req = {
                            "token": result
                        }
                        dispatch(comCheckFuelCardTransactionAction(req));
                    });

                }

            }
            // dispatch(comCheckFuelCardTransactionAction(fuelCardRequest));
        }


    }

    return (
        <React.Fragment>
            <Modal
                className="fade contest_input_modal"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <form className="form-fuelCard" onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Dialog className="modal-dialog-centered modal-our">

                        <Modal.Body>

                            <div className="row">
                                <div className="col-md-12">
                                    {fieldsArr && fieldsArr.map(element => {
                                        return (
                                            <>
                                                {element}
                                            </>
                                        )
                                    })}
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer className="border-0 justify-content-center pb-5">
                            <button type="button" className="btn btn-outline-dark" style={{ minWidth: '100px' }} onClick={handleClose}>
                                Close</button>
                            <LoaderSubmitButton
                                name='Submit'
                                className="btn btn-chartreuse"
                                loading={comCheckFuelCardtTransaction.loading}
                            />
                        </Modal.Footer>
                    </Modal.Dialog>
                </form>

            </Modal>

        </React.Fragment>
    )
}

export default ComCheckFuelCardDialog;